<template>
  <!-- banner topo -->
  <div v-if="bannerTopo != ''" class="bannerTopo-area">
    <div class="bannerTopo-height d-flex align-items-center">

      <div class="bannerTopo-img">
        <img :src="$imgURL + bannerTopo[0].insInstitucionalImagens[0].itgUrlImagem" class="bannerTopo-bg-fill" alt="">
      </div>

      <div class="bannerTopo-overlay"></div>

      <div class="container">
        <div class="row justify-content-center">
          <div class="col-xl-8 col-lg-10">
            <div class="bannerTopo-caption text-center">
              <h2>{{ bannerTopo[0].itiNome }}</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- informações gerais -->
  <section class="lgpd-section">
    <div class="lgpd-container">
      <div class="lgpd-row">

        <aside class="lgpd-col-menu">
          <div class="lgpd-filter-card">
            <ul class="lgpd-menu-list">
              <li v-for="(menu, menuIndex) in informacoes" :key="menuIndex">
                <a href="#" @click.prevent="carregaTexto(menu.itiId)">{{ menu.itiNome }}</a>
              </li>
            </ul>
          </div>
        </aside>

        <article v-if="informacao != ''" class="lgpd-col-content">
          <h3 class="lgpd-content-title">{{ informacao[0].itiNome }}</h3>
          <div class="lgpd-text">
            <p v-html="informacao[0].itiResumo1"></p>
          </div>
        </article>

      </div>
    </div>
  </section>

</template>

<script>
import { useHead } from '@vueuse/head'
import axios from 'axios';
import { useRoute } from 'vue-router';

export default {
  name: 'InformacoesView',
  components: {
  },

  setup() {
    const route = useRoute();
    const id = route.params.id;
    const nome = route.params.nome;
    return {
      id,
      nome
    };
  },

  data: () => ({
    bannerTopo: [],
    informacoes: [],
    informacao: [],
  }),

  methods: {

    carregaMetas(texto, titulo) {
      useHead({
        title: 'Lukon :: ' + titulo,
        meta: [
          { name: "description", content: texto },
          { name: "author", content: "Avance Digital" },
          { httpEquiv: "Content-Language", content: "pt-BR" },
          { charset: "UTF-8" },
          { name: "robots", content: "index, follow" },
        ],
      })
    },

    removerTagsHTML(html) {
      const element = document.createElement('div');
      element.innerHTML = html;
      return element.textContent || element.innerText || '';
    },

    carregaTexto(value) {
      this.informacao = this.informacoes.filter(x => x.itiId == value)
      if (this.informacao.length > 0) {
        this.carregaMetas(
          this.removerTagsHTML(this.informacao[0].itiResumo1 || ''),
          this.informacao[0].itiNome || 'Informações'
        );
      }
    },
    
  },

  created() {
    this.carregaMetas();

    // BANNER TOPO
    axios.get('/Process/InsInstitucional/institucional/53/topoinformacoes/0/x')
      .then(response => {
        this.bannerTopo = response.data;
        //console.log('banner topo')
        //console.log(this.bannerTopo)
      })
      .catch(error => {
        console.error(error);
      });

    // INFORMACOES
    axios.get('/Process/InsInstitucional/institucional/54/listadasinformacoes/0/x')
      .then(response => {
        this.informacoes = response.data.filter(x => x.itiVisivel).sort((a, b) => a.itiOrdem - b.itiOrdem);

        if (this.id) {
          this.carregaTexto(this.id);
        }
        else {
          this.carregaTexto(this.informacoes[0].itiId);
        }
        this.carregaMetas(this.removerTagsHTML, this.informacao[0].itiNome);
      })
      .catch(error => {
        console.error(error);
      });

  },
}
</script>

<style scoped></style>